module.exports = __webpack_public_path__ + "img/pump-north.de08dd83.png";